module.exports = __webpack_public_path__ + "media/home1-right.7dfffa30.mp4";